"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadSimulatorLabelValue = exports.ThumbLabelValue = exports.EdgeConnectLabelValue = exports.VideoLabelValue = exports.VideoStandbyLabelValue = exports.KubernetesRoles = exports.KubernetesLabels = void 0;
var KubernetesLabels;
(function (KubernetesLabels) {
    KubernetesLabels["video"] = "video";
    KubernetesLabels["video_standby"] = "video_standby";
    KubernetesLabels["region"] = "region";
    KubernetesLabels["default_region"] = "default_region";
    KubernetesLabels["core"] = "core";
    KubernetesLabels["thumb"] = "thumb";
    KubernetesLabels["edge_connect"] = "edge_connect";
    KubernetesLabels["load_simulator"] = "load_simulator";
})(KubernetesLabels || (exports.KubernetesLabels = KubernetesLabels = {}));
var KubernetesRoles;
(function (KubernetesRoles) {
    KubernetesRoles["core"] = "core";
    KubernetesRoles["thumb"] = "thumb";
    KubernetesRoles["video"] = "video";
    KubernetesRoles["video_standby"] = "video_standby";
    KubernetesRoles["edge_connect"] = "edge_connect";
    KubernetesRoles["load_simulator"] = "load_simulator";
})(KubernetesRoles || (exports.KubernetesRoles = KubernetesRoles = {}));
var VideoStandbyLabelValue;
(function (VideoStandbyLabelValue) {
    VideoStandbyLabelValue["standby"] = "standby";
})(VideoStandbyLabelValue || (exports.VideoStandbyLabelValue = VideoStandbyLabelValue = {}));
var VideoLabelValue;
(function (VideoLabelValue) {
    VideoLabelValue["enabled"] = "true";
})(VideoLabelValue || (exports.VideoLabelValue = VideoLabelValue = {}));
var EdgeConnectLabelValue;
(function (EdgeConnectLabelValue) {
    EdgeConnectLabelValue["enabled"] = "true";
})(EdgeConnectLabelValue || (exports.EdgeConnectLabelValue = EdgeConnectLabelValue = {}));
var ThumbLabelValue;
(function (ThumbLabelValue) {
    ThumbLabelValue["enabled"] = "true";
})(ThumbLabelValue || (exports.ThumbLabelValue = ThumbLabelValue = {}));
var LoadSimulatorLabelValue;
(function (LoadSimulatorLabelValue) {
    LoadSimulatorLabelValue["enabled"] = "true";
})(LoadSimulatorLabelValue || (exports.LoadSimulatorLabelValue = LoadSimulatorLabelValue = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFiZWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2s4cy9sYWJlbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxnQkFTWDtBQVRELFdBQVksZ0JBQWdCO0lBQ3hCLG1DQUFlLENBQUE7SUFDZixtREFBK0IsQ0FBQTtJQUMvQixxQ0FBaUIsQ0FBQTtJQUNqQixxREFBaUMsQ0FBQTtJQUNqQyxpQ0FBYSxDQUFBO0lBQ2IsbUNBQWUsQ0FBQTtJQUNmLGlEQUE2QixDQUFBO0lBQzdCLHFEQUFpQyxDQUFBO0FBQ3JDLENBQUMsRUFUVyxnQkFBZ0IsZ0NBQWhCLGdCQUFnQixRQVMzQjtBQUVELElBQVksZUFRWDtBQVJELFdBQVksZUFBZTtJQUN2QixnQ0FBYSxDQUFBO0lBQ2Isa0NBQWUsQ0FBQTtJQUNmLGtDQUFlLENBQUE7SUFDZixrREFBK0IsQ0FBQTtJQUMvQixnREFBNkIsQ0FBQTtJQUU3QixvREFBaUMsQ0FBQTtBQUNyQyxDQUFDLEVBUlcsZUFBZSwrQkFBZixlQUFlLFFBUTFCO0FBRUQsSUFBWSxzQkFFWDtBQUZELFdBQVksc0JBQXNCO0lBQzlCLDZDQUFtQixDQUFBO0FBQ3ZCLENBQUMsRUFGVyxzQkFBc0Isc0NBQXRCLHNCQUFzQixRQUVqQztBQUVELElBQVksZUFFWDtBQUZELFdBQVksZUFBZTtJQUN2QixtQ0FBZ0IsQ0FBQTtBQUNwQixDQUFDLEVBRlcsZUFBZSwrQkFBZixlQUFlLFFBRTFCO0FBRUQsSUFBWSxxQkFFWDtBQUZELFdBQVkscUJBQXFCO0lBQzdCLHlDQUFnQixDQUFBO0FBQ3BCLENBQUMsRUFGVyxxQkFBcUIscUNBQXJCLHFCQUFxQixRQUVoQztBQUVELElBQVksZUFFWDtBQUZELFdBQVksZUFBZTtJQUN2QixtQ0FBZ0IsQ0FBQTtBQUNwQixDQUFDLEVBRlcsZUFBZSwrQkFBZixlQUFlLFFBRTFCO0FBRUQsSUFBWSx1QkFFWDtBQUZELFdBQVksdUJBQXVCO0lBQy9CLDJDQUFnQixDQUFBO0FBQ3BCLENBQUMsRUFGVyx1QkFBdUIsdUNBQXZCLHVCQUF1QixRQUVsQyJ9